import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { initialPersonnelState } from './personnel.state';

const personnelSlice = createSlice({
  name: 'personnel',
  initialState: initialPersonnelState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setSelectedPersonnelId: (state, action: PayloadAction<string | null>) => {
      state.selectedPersonnelId = action.payload;
    },
    setModalMode: (state, action: PayloadAction<'add' | 'edit'>) => {
      state.modalMode = action.payload;
    },
    clearSelection: (state) => {
      state.selectedPersonnelId = null;
      state.modalMode = 'add';
    },
    openAddModal: (state) => {
      state.selectedPersonnelId = null;
      state.modalMode = 'add';
      state.isModalOpen = true;
    },
    openEditModal: (state, action: PayloadAction<string>) => {
      state.selectedPersonnelId = action.payload;
      state.modalMode = 'edit';
      state.isModalOpen = true;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
      state.selectedPersonnelId = null;
      state.modalMode = 'add';
    },
    setSortOption: (state, action: PayloadAction<{ field: 'name' | 'updated_at'; order: 'asc' | 'desc' }>) => {
      state.sortField = action.payload.field;
      state.sortOrder = action.payload.order;
    },
  },
});

export const {
  setSearchTerm,
  setModalOpen,
  setSelectedPersonnelId,
  setModalMode,
  clearSelection,
  openAddModal,
  openEditModal,
  closeModal,
  setSortOption,
} = personnelSlice.actions;

export default personnelSlice.reducer;
